import axios from "../../fetch-api/fetch-api";

export function loadLocaleFromJson(ln: string, ns: string) {
  const versionQuery = `?version=${window.version}`;
  if (process.env.NODE_ENV === "development") {
    return axios.json(`http://localhost:3000/locales/${ln}/${ns}.json${versionQuery}`);
  }
  return axios.json(`${window.location.origin}/locales/${ln}/${ns}.json${versionQuery}`);
}
